import { Icon, Paragraph, Subtitle, TextButton } from '@joor/design-system'
import { useErrorBoundary } from 'react-error-boundary'
import styled from 'styled-components/macro'

import { StyledCard } from '../../ProductsWidget'
import messages from '../../constants/messages'

export function Error({ actionButtonLabel, onClickActionButton }: Props) {
  const { resetBoundary } = useErrorBoundary()
  return (
    <StyledCard
      title={messages.widgetHeader}
      actionButtonLabel={actionButtonLabel}
      onClickActionButton={onClickActionButton}
    >
      <Container data-testid={ErrorTestIds.ErrorContainer}>
        <Icon
          data-testid={ErrorTestIds.ResetIcon}
          iconName="reset"
          plain
          iconSize="extraLarge"
        />
        <Subtitle type="1" typeface="montserrat">
          {messages.error.title}
        </Subtitle>
        <Paragraph type="3" typeface="montserrat" textAlign="center">
          {messages.error.message}
          <br />
          {
            <TextButton onClick={() => resetBoundary()}>
              {messages.error.reload}
            </TextButton>
          }{' '}
          {messages.error.tryAgain}
        </Paragraph>
      </Container>
    </StyledCard>
  )
}

type Props = {
  actionButtonLabel?: string
  onClickActionButton?: () => void
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-block: 32px 52px;
  gap: 8px;

  p {
    margin: 0;
  }
`

export const ErrorTestIds = {
  ErrorContainer: 'error-container',
  ResetIcon: 'error-reset-icon',
} as const
